import settings from 'settings';
import { message } from 'antd';
import * as beaver from 'beaver-logger';

class Logger {
  constructor() {
    if (!this.logger) {
      this.logger = beaver.Logger({
        url: `${settings.BASE_API_DOMAIN()}api/logs/`,
        flushInterval: 60 * 1000
      });
    }
  }

  info(msg, displayAlert = false) {
    this.logger.info(msg);
    displayAlert && message.info(msg);
  }

  warn(msg, displayAlert = false) {
    this.logger.warn(msg);
    displayAlert && message.warn(msg);
  }

  error(msg, displayAlert = false) {
    this.logger.error(msg);
    displayAlert && message.error(msg);
  }
}

export default new Logger();
